<template>
  <div class="onePage">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'one-page-layout',
};
</script>

<style scoped>
  .onePage{
    height: 100vh;
    display: flex;
    justify-content: center;
    align-content: center;
    width: 100%;
    flex-wrap: wrap;
  }
</style>
